module.exports = __webpack_public_path__ + "img/expenses.5c2b29c4.svg";